module.exports = __webpack_public_path__ + "static/media/landing-background.f95d2e04.png";